import { StatusPageConfig } from '../app/types/status-page-config.types';

/**
 * Build-time defaults. Deployments override any of these at runtime through
 * `assets/status-page.config.json` (see StatusPageConfigService), so one build
 * serves every environment — the page must be deployable as plain static files.
 */
export const environment: StatusPageConfig = {
  gatewayUrl: 'http://localhost:30080',
  refreshIntervalInSeconds: 30,
  logoSrc: 'assets/logo/logo.svg',
  title: 'Finverity System Status',
  company: 'Finverity',
};
